module.exports = __webpack_public_path__ + "vue_assets/img/img_assetpack_evillairs.f5633842.jpg";